import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./modules/home/screens";
import App from "./App";
import IndividualsScreen from "@modules/fauna/individuals/screens";
import LoginScreen from "@modules/auth/screens";
import { paths } from "./paths";
import { AuthGuard } from "@modules/auth/authGuard";
import { GuestGuard } from "@modules/auth/guestGuard";
import NotFound from "@commons/NotFound";
import TaxonomicGroupsScreen from "@modules/fauna/taxonomicGroups/screens";
import ManagingReleasesScreen from "@modules/managingReleases/screens";
import ViewIndividual from "@modules/fauna/individuals/screens/ViewIndividual";
import ViewRelease from "@modules/managingReleases/screens/ViewRelease";
import ReportsScreen from "@modules/reports/screens";
import RegistersScreen from "@modules/fauna/registers/screens";
import ViewRegister from "@modules/fauna/registers/screens/ViewRegister";
import ViewSample from "@modules/fauna/samples/screens/ViewSample";
import SamplesScreen from "@modules/fauna/samples/screens";
import CommunityScreen from "@modules/community/screens";
import ViewLocation from "@modules/community/screens/viewLocation";
import DevicesScreen from "@modules/devices/screens";
import ViewCameraTrap from "@modules/devices/components/cameraTrap/ViewCameraTrap";
import ViewCollar from "@modules/devices/components/collar/ViewCollar";
import UsersScreen from "@modules/users/screens";
import ProfileScreen from "@modules/profile/screens";
import NotificationsScreen from "@modules/notifications/screens";
import { ROLES } from "@typings/entities/users/enums";

function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path={paths.auth}
          element={
            <GuestGuard>
              <LoginScreen />
            </GuestGuard>
          }
        />
        <Route
          path={paths.home}
          element={
            <AuthGuard>
              <App />
            </AuthGuard>
          }
        >
          <Route index element={<Home />} />

          <Route path={paths.profile} element={<ProfileScreen />} />

          <Route path={paths.individuals}>
            <Route index element={<IndividualsScreen />} />
            <Route path=":id" element={<ViewIndividual />} />
          </Route>

          <Route
            path={paths.taxonomicGroups}
            element={<TaxonomicGroupsScreen />}
          />

          <Route path={paths.registers}>
            <Route index element={<RegistersScreen />} />
            <Route path=":id" element={<ViewRegister />} />
          </Route>

          <Route path={paths.samples}>
            <Route index element={<SamplesScreen />} />
            <Route path=":id" element={<ViewSample />} />
          </Route>

          <Route path={paths.community}>
            <Route index element={<CommunityScreen />} />
            <Route path=":id" element={<ViewLocation />} />
          </Route>

          <Route path={paths.devices}>
            <Route index element={<DevicesScreen />} />
            <Route path="camera-trap/:id" element={<ViewCameraTrap />} />
            <Route path="collar/:id" element={<ViewCollar />} />
          </Route>

          <Route path={paths.managingReleases}>
            <Route index element={<ManagingReleasesScreen />} />
            <Route path=":id" element={<ViewRelease />} />
          </Route>
          <Route path={paths.reports} element={<ReportsScreen />} />

          <Route
            path={paths.users}
            element={
              <AuthGuard roles={[ROLES.ADMIN]}>
                <UsersScreen />
              </AuthGuard>
            }
          />

          <Route path={paths.notifications} element={<NotificationsScreen />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;
